import { BackgroundAnimationType, BackgroundEvent } from "../types";

export const sendBgControlEvent = (
  parent: HTMLElement,
  step: number,
  eventName: Exclude<BackgroundAnimationType, "none" | "morph">,
  action: BackgroundEvent["detail"]["action"]
) => {
  const evt = new CustomEvent("bgControl", {
    detail: { eventName, action, step },
  });
  parent.dispatchEvent(evt);
};

export const isImmediateBgControl = (
  bgControl: BackgroundAnimationType | undefined
): bgControl is Exclude<BackgroundAnimationType, "none" | "morph"> => {
  return (
    bgControl === "zoom" || bgControl === "zoom-strong" || bgControl === "reset"
  );
};

export const sendTextToHeaderEvent = (
  element: HTMLElement,
  action: "add" | "remove"
) => {
  const evt = new CustomEvent("textToHeader", { detail: { element, action } });
  window.dispatchEvent(evt);
};

export const isFirst = (section: HTMLElement, triggerElement: HTMLElement) => {
  const slides = Array.from(
    triggerElement.querySelectorAll<HTMLElement>(".scrollytelling__slide")
  );

  return slides[0] === section;
};

export const shouldApplyInitialBgControl = (
  section: HTMLElement,
  triggerElement: HTMLElement,
  bgControl: BackgroundAnimationType | undefined
) => {
  return (
    window.scrollY === 0 &&
    isFirst(section, triggerElement) &&
    isImmediateBgControl(bgControl)
  );
};
